module.exports = __webpack_public_path__ + "img/Feature.520bbcd3.png";